<style lang="scss">






@media screen and (min-width: 55rem) {
  .membershipcomparison {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: white;
    margin-top: 5rem;

    .membershipbannercard-top {
      width: 80%;
      max-width: 1080px;
      height: 10rem;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      .membershipbannercard-top-subtitle {
        font-size: 1rem;
        font-family:  'PingFang SC','Microsoft YaHei';
        font-weight: 500;
        color: #e5004f;
        line-height: 3.25rem;
      }
      .membershipbannercard-top-title {
        font-size: 2rem;
        font-family:  'PingFang SC','Microsoft YaHei';
        font-weight: bold;
        color: #4b4b4b;
      }
      .membershipbannercard-top-line {
        width: 2rem;
        height: 0.25rem;
        background-color: #e5004f;
        margin-top: 1rem;
      }
    }
    .membershipcomparison-table {
      width: 80%;
      max-width: 1080px;

      display: flex;
      flex-direction: column;
      margin-top: 5rem;
      .membershipcomparison-table-header {
        height: 3.8rem;
        width: 100%;
        background-color: rgba(150, 142, 142, 0.587);
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;

        .membershipcomparison-table-header-left {
          text-align: right;
          width: 62%;
          font-size: 1.4375rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #000000;
        }
        .membershipcomparison-table-header-middle {
          text-align: center;
          width: 14%;
          font-size: 1.4375rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #000000;
        }
        .membershipcomparison-table-header-right {
          text-align: left;
          width: 24%;
          font-size: 1.4375rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #000000;
        }
      }
      .membershipcomparison-table-shop {
        width: 100%;
        height: 15.2rem;
        border-bottom: 2px #000000 solid;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;

        .membershipcomparison-table-shop-left {
          width: 20%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 15.2rem;
          .membershipcomparison-table-shop-left-title {
            font-size: 1.18rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #000000;
            line-height: 2.31rem;
          }
        }
        .membershipcomparison-table-shop-right {
          width: 80%;
          height: 100%;
          display: flex;
          flex-direction: column;
          .membershipcomparison-table-shop-item {
            width: 100%;
            height: 3.8rem;
            border-bottom: 1px #000000 solid;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            .membershipcomparison-table-shop-item-title {
              width: 32%;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              margin-right: 25%;
              .membershipcomparison-table-shop-item-title-item {
                font-family:  'PingFang SC','Microsoft YaHei';
              }
            }
            .membershipcomparison-table-shop-item-member {
              width: 32%;
              font-family:  'PingFang SC','Microsoft YaHei';
            }
            .membershipcomparison-table-shop-item-intime365 {
              width: 32%;
              font-family:  'PingFang SC','Microsoft YaHei';
            }
          }
        }
      }
      .membershipcomparison-table-arrive {
        width: 100%;
        height: 19rem;
        border-bottom: 2px #000000 solid;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;

        .membershipcomparison-table-arrive-left {
          width: 20%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 19rem;
          .membershipcomparison-table-arrive-left-title {
            font-size: 1.18rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #000000;
            line-height: 2.31rem;
          }
        }
        .membershipcomparison-table-arrive-right {
          width: 80%;
          height: 100%;
          display: flex;
          flex-direction: column;
          .membershipcomparison-table-arrive-item {
            width: 100%;
            height: 3.8rem;
            border-bottom: 1px #000000 solid;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            .membershipcomparison-table-arrive-item-title {
              width: 32%;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              margin-right: 25%;
              .membershipcomparison-table-arrive-item-title-item {
                font-family:  'PingFang SC','Microsoft YaHei';
              }
            }
            .membershipcomparison-table-arrive-item-member {
              width: 32%;
              font-family:  'PingFang SC','Microsoft YaHei';
              position: relative;
            }
            .membershipcomparison-table-arrive-item-intime365 {
              font-family:  'PingFang SC','Microsoft YaHei';
              width: 32%;
            }
          }
        }
      }
      .membershipcomparison-table-serve {
        width: 100%;
        height: 7.6rem;
        border-bottom: 2px #000000 solid;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;

        .membershipcomparison-table-serve-left {
          width: 20%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 7.6rem;
          .membershipcomparison-table-serve-left-title {
            font-size: 1.18rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #000000;
            line-height: 2.31rem;
          }
        }
        .membershipcomparison-table-serve-right {
          width: 80%;
          height: 100%;
          display: flex;
          flex-direction: column;
          .membershipcomparison-table-serve-item {
            width: 100%;
            height: 3.8rem;
            border-bottom: 1px #000000 solid;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            .membershipcomparison-table-serve-item-title {
              width: 32%;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              margin-right: 25%;
              .membershipcomparison-table-serve-item-title-item {
                font-family:  'PingFang SC','Microsoft YaHei';
              }
            }
            .membershipcomparison-table-serve-item-member {
              width: 32%;
              font-family:  'PingFang SC','Microsoft YaHei';
            }
            .membershipcomparison-table-serve-item-intime365 {
              width: 32%;
              font-family:  'PingFang SC','Microsoft YaHei';
            }
          }
        }
      }
    }
    .membershipcomparison-bottom {
      width: 80%;
      max-width: 1080px;

      margin-top: 1rem;
      .membershipcomparison-bottom-item {
        font-family:  'PingFang SC','Microsoft YaHei';
        color: #7f7f7f;
        font-size: 1.3125rem;
        font-weight: 400;
      }
    }
  }
}
@media screen and (max-width: 55rem) {
  .membershipcomparison {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: white;
    margin-top: 2rem;

    .membershipbannercard-top {
      width: 80%;
      height: 10rem;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      .membershipbannercard-top-subtitle {
        font-size: 1rem;
        font-family:  'PingFang SC','Microsoft YaHei';
        font-weight: 500;
        color: #e5004f;
        line-height: 3.25rem;
      }
      .membershipbannercard-top-title {
        font-size: 2rem;
        font-family:  'PingFang SC','Microsoft YaHei';
        font-weight: bold;
        color: #4b4b4b;
      }
      .membershipbannercard-top-line {
        width: 2rem;
        height: 0.25rem;
        background-color: #e5004f;
        margin-top: 1rem;
      }
    }
    .membershipcomparison-table {
      width: 80%;
      display: flex;
      flex-direction: column;
      margin-top: 2rem;
      .membershipcomparison-table-header {
        height: 3.8rem;
        width: 100%;
        background-color: rgba(150, 142, 142, 0.587);
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;

        .membershipcomparison-table-header-left {
          text-align: right;
          width: 70%;
          font-size: 1rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #000000;
        }
        .membershipcomparison-table-header-middle {
          text-align: center;
          width: 5%;
          font-size: 1rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #000000;
        }
        .membershipcomparison-table-header-right {
          text-align: center;
          width: 25%;
          font-size: 1rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #000000;
        }
      }
      .membershipcomparison-table-shop {
        width: 100%;
        height: 15.2rem;
        border-bottom: 2px #000000 solid;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;

        .membershipcomparison-table-shop-left {
          width: 10%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 15.2rem;
          .membershipcomparison-table-shop-left-title {
            width: 2rem;
            font-size: 1.18rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #000000;
            line-height: 2.31rem;
          }
        }
        .membershipcomparison-table-shop-right {
          width: 90%;
          height: 100%;
          display: flex;
          flex-direction: column;
          .membershipcomparison-table-shop-item {
            width: 100%;
            height: 3.8rem;
            border-bottom: 1px #000000 solid;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            .membershipcomparison-table-shop-item-title {
              width: 60%;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              .membershipcomparison-table-shop-item-title-item {
                font-family:  'PingFang SC','Microsoft YaHei';
              }
            }
            .membershipcomparison-table-shop-item-member {
              width: 20%;
              font-family:  'PingFang SC','Microsoft YaHei';
            }
            .membershipcomparison-table-shop-item-intime365 {
              width: 20%;
              font-family:  'PingFang SC','Microsoft YaHei';
            }
          }
        }
      }
      .membershipcomparison-table-arrive {
        width: 100%;
        height: 19rem;
        border-bottom: 2px #000000 solid;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;

        .membershipcomparison-table-arrive-left {
          width: 10%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 19rem;
          .membershipcomparison-table-arrive-left-title {
            width: 2rem;
            font-size: 1.18rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #000000;
            line-height: 2.31rem;
          }
        }
        .membershipcomparison-table-arrive-right {
          width: 90%;
          height: 100%;
          display: flex;
          flex-direction: column;
          .membershipcomparison-table-arrive-item {
            width: 100%;
            height: 3.8rem;
            border-bottom: 1px #000000 solid;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            .membershipcomparison-table-arrive-item-title {
              width: 60%;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              .membershipcomparison-table-arrive-item-title-item {
                font-family:  'PingFang SC','Microsoft YaHei';
              }
            }
            .membershipcomparison-table-arrive-item-member {
              width: 20%;
              font-family:  'PingFang SC','Microsoft YaHei';
            }
            .membershipcomparison-table-arrive-item-intime365 {
              width: 20%;
              font-family:  'PingFang SC','Microsoft YaHei';
            }
          }
        }
      }
      .membershipcomparison-table-serve {
        width: 100%;
        height: 9rem;
        border-bottom: 2px #000000 solid;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;

        .membershipcomparison-table-serve-left {
          width: 10%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 9rem;
          .membershipcomparison-table-serve-left-title {
            width: 2rem;
            font-size: 1.18rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #000000;
            line-height: 2.31rem;
          }
        }
        .membershipcomparison-table-serve-right {
          width: 90%;
          height: 100%;
          display: flex;
          flex-direction: column;
          .membershipcomparison-table-serve-item {
            width: 100%;
            height: 3.8rem;
            border-bottom: 1px #000000 solid;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            .membershipcomparison-table-serve-item-title {
              width: 60%;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              .membershipcomparison-table-serve-item-title-item {
                font-family:  'PingFang SC','Microsoft YaHei';
              }
            }
            .membershipcomparison-table-serve-item-member {
              font-family:  'PingFang SC','Microsoft YaHei';
              width: 20%;
            }
            .membershipcomparison-table-serve-item-intime365 {
              width: 20%;
              font-family:  'PingFang SC','Microsoft YaHei';
            }
          }
        }
      }
    }
    .membershipcomparison-bottom {
      width: 80%;
      margin-top: 1rem;
      .membershipcomparison-bottom-item {
        font-family:  'PingFang SC','Microsoft YaHei';
        color: #7f7f7f;
        font-size: 1.3125rem;
        font-weight: 400;
      }
    }
  }
}
</style>

<script>
export default {
  name: "membershipcomparison",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
